import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PlatformModeService } from '../../services/platform-mode.service';
import { PlatformMode } from '../../models/platform-mode.model';

@Component({
  selector: 'flex-privacy-policy-intro',
  imports: [TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './intro.component.html',
  styleUrl: './intro.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntroComponent {
  private readonly platformModeService = inject(PlatformModeService);
  readonly mode: PlatformMode = this.platformModeService.getMode();
}
